// extracted by mini-css-extract-plugin
export default {"filter":"FilterTitle_filter__f7KY-","title":"FilterTitle_title__FtYRN","closeicon":"FilterTitle_closeicon__uDZ23"};